import { usePage } from '@inertiajs/react';

const useFeatureFlags = () => {
  const {
    features: {
      sale_banner_enabled: saleBannerEnabled,
      banner_ads_enabled: bannerAdsEnabled,
      recurring_ads_interest_enabled: recurringAdsInterestEnabled,
    },
  } = usePage<{
    features: {
      sale_banner_enabled: boolean;
      banner_ads_enabled: boolean;
      recurring_ads_interest_enabled: boolean;
    };
  }>().props;
  return {
    saleBannerEnabled,
    bannerAdsEnabled,
    recurringAdsInterestEnabled,
  };
};
export default useFeatureFlags;
